import React from 'react';

type Section = {
  title: string;
  description: string | string[];
};

type Props = {
  content: Section[] | string[];
  type?: 'card' | 'drawer';
};

const isSectionArray = (content: Section[] | string[]): content is Section[] => {
  return content.length > 0 && typeof content[0] === 'object' && 'title' in content[0];
};

export const InfoSection: React.FC<Props> = ({ content, type = 'drawer' }) => {
  if (isSectionArray(content)) {
    return (
      <div className="flex flex-col gap-y-6 text-sm [&_ul]:m-0 [&_ul]:p-0 [&_ul]:pl-4 [&_ul]:list-disc text-primary-main">
        {content.map((section) => (
          <div
            key={section.title}
            className={`flex flex-col ${type === 'card' ? ' gap-y-3' : ' gap-y-2'}`}
          >
            <div className="font-medium">{section.title}</div>
            <div>
              {Array.isArray(section.description) ? (
                <div className={`flex flex-col pl-0 ${type === 'card' ? 'gap-y-5' : 'gap-y-2'}`}>
                  {section.description.map((desc) => (
                    <div key={desc} dangerouslySetInnerHTML={{ __html: desc }} />
                  ))}
                </div>
              ) : (
                <div
                  dangerouslySetInnerHTML={{ __html: section.description }}
                  className="list-disc"
                />
              )}
            </div>
          </div>
        ))}
      </div>
    );
  } else {
    return (
      <div className={`flex flex-col gap-y-4 text-primary-main`}>
        {content.map((section) => (
          <div key={section} dangerouslySetInnerHTML={{ __html: section }} />
        ))}
      </div>
    );
  }
};
